import Http from '../http'

export const getCoupons = (page, search) => Http.get(`/coupons?page=${page}&search=${search}`, { headers: { Authorization: localStorage.token } })
export const show = (id) => Http.get(`/coupons/${id}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/coupons', { data }, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/coupons/${id}`, { data }, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/coupons/${id}`, { headers: { Authorization: localStorage.token } })
export const excel = (from, to) => Http.get(`/export-excel?from=${from}&to=${to}`, { headers: { Authorization: localStorage.token } })
